import React, { useState } from 'react'
import { Button, Modal, QuantityInput } from '../../../../components'
import { LiteralsService } from '../../../../services'
import StyledSection from './styles'

interface IProps {
  visible: boolean
  seats: number
  prmSeats: number
  showPrm: boolean
  onSave: (seats: number, prmSeats: number) => any
  close: () => void
}

export const SeatsModal: React.FC<IProps> = ({ visible, seats, prmSeats, showPrm, onSave, close }) => {
  const [currentSeats, setCurrentSeats] = useState(seats)
  const [currentPrmSeats, setCurrentPrmSeats] = useState(prmSeats)
  const hasMinimumSeats = (currentSeats + currentPrmSeats) >= 1

  const handleChangeSeats = (newSeats: number) => {
    setCurrentSeats(newSeats)
  }

  const handleChangePrmSeats = (newPrmSeats: number) => {
    setCurrentPrmSeats(newPrmSeats)
  }

  const handleSave = () => {
    if (hasMinimumSeats) onSave(currentSeats, currentPrmSeats)
  }

  const handleClose = () => {
    setCurrentSeats(seats)
    setCurrentPrmSeats(prmSeats)
    close()
  }

  return (
    <Modal isHidden={ !visible } onOverlayClick={ close } >
      <StyledSection>
        <header>
          <h3>{ LiteralsService.get('selectSeats', true).toUpperCase() }</h3>
        </header>
        <section>
          <QuantityInput
            label={ LiteralsService.get('seat', true) }
            amount={ currentSeats }
            onChange={ handleChangeSeats }
          />
          {
            showPrm &&
            <QuantityInput
              label={ LiteralsService.get('prmSeat', true) }
              amount={ currentPrmSeats }
              onChange={ handleChangePrmSeats }
            />
          }
        </section>
        <footer>
          <Button
            title={ LiteralsService.get('confirm') }
            onPress={ handleSave }
            isDisabled={ !hasMinimumSeats }
            filled
            upper
          />
          <Button
            title={ LiteralsService.get('close') }
            onPress={ handleClose }
            upper
          />
        </footer>
      </StyledSection>
    </Modal>
  )
}
